import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-686ff245")
const _hoisted_1 = {
  key: 0,
  class: "center padding"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "demands"
}
const _hoisted_5 = { class: "demand-all" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "demand-waiting" }
const _hoisted_8 = { class: "state-waiting" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "demand-processing" }
const _hoisted_11 = { class: "state-processing" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "demand-done" }
const _hoisted_14 = { class: "state-done" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "demand-abort" }
const _hoisted_17 = { class: "state-abort" }
const _hoisted_18 = ["title"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "demands-card" }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$tc('nbDemand', _ctx.allDemands.length)) + " ", 1),
              _createElementVNode("dig-ui-icon", {
                type: "show",
                title: _ctx.$t('goToDemands'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToDemands()))
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("dig-ui-badge", _hoisted_8, _toDisplayString(_ctx.allDemands.filter((d) => d.state === _ctx.DEMAND_STATES.WAITING).length) + " " + _toDisplayString(_ctx.$t('Demand.State.' + _ctx.DEMAND_STATES.WAITING)), 1),
              _createElementVNode("dig-ui-icon", {
                type: "show",
                title: _ctx.$t('goToDemands'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDemands(_ctx.DEMAND_STATES.WAITING)))
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("dig-ui-badge", _hoisted_11, _toDisplayString(_ctx.allDemands.filter((d) => d.state === _ctx.DEMAND_STATES.PROCESSING)
              .length) + " " + _toDisplayString(_ctx.$t('Demand.State.' + _ctx.DEMAND_STATES.PROCESSING)), 1),
              _createElementVNode("dig-ui-icon", {
                type: "show",
                title: _ctx.$t('goToDemands'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToDemands(_ctx.DEMAND_STATES.PROCESSING)))
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("dig-ui-badge", _hoisted_14, _toDisplayString(_ctx.allDemands.filter((d) => d.state === _ctx.DEMAND_STATES.DONE).length) + " " + _toDisplayString(_ctx.$t('Demand.State.' + _ctx.DEMAND_STATES.DONE)), 1),
              _createElementVNode("dig-ui-icon", {
                type: "show",
                title: _ctx.$t('goToDemands'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToDemands(_ctx.DEMAND_STATES.DONE)))
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("dig-ui-badge", _hoisted_17, _toDisplayString(_ctx.allDemands.filter((d) => d.state === _ctx.DEMAND_STATES.ABORT).length) + " " + _toDisplayString(_ctx.$t('Demand.State.' + _ctx.DEMAND_STATES.ABORT)), 1),
              _createElementVNode("dig-ui-icon", {
                type: "show",
                title: _ctx.$t('goToDemands'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToDemands(_ctx.DEMAND_STATES.ABORT)))
              }, null, 8, _hoisted_18)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}